import script from "./PromoListItem.vue?vue&type=script&setup=true&lang=js"
export * from "./PromoListItem.vue?vue&type=script&setup=true&lang=js"

import "./PromoListItem.vue?vue&type=style&index=0&id=2420940c&lang=scss"

const __exports__ = script;

export default __exports__